module.exports = __webpack_public_path__ + "static/img/icon4--05 1.d16dbe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon4--05 1.png
// module id = O4OF
// module chunks = 1